import React from 'react'

import imageTwo from '../images/2G5A3292.jpg'
import imageThree from '../images/2G5A3587.jpg'

const testData = {
  title: "The Calf",
  type: "Short Film",
  attribution: "Written + Directed by Mathew Sunderland and Simon London",
  company: "Grifter Films",
  sponsor: "NZFC",
  images: [
    imageThree,
    imageTwo
  ],
  info: [
    {
      text: 'I was alongside this team for the entire casting process, rehearsals and on set. I coached these three wonderful young actors',
      cast: 'Jack Goodwyn Archer (13), June VanGriffin (11) and Arthur Solomon - Mua (13).'
    }
  ],
  quotes: [
    {
      attribution: 'Simon London, director of The Calf (NZFC), 2019',
      text: 'Prodégé to NZ’s coaching legend Miranda Harcourt, Ella was with us throughout the casting process and then all the way through pre production, workshops, rehearsals and finally on set. She’s got an incredible ability to bring the best out of young actors.'
    }
  ]
}

function ProjectPage() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-6">
          <img 
            src={testData.images[0]}
            className="main-img" />
          <br/>
          <br/>
          <br/>
          <img 
            src={testData.images[1]}
            className="main-img" />
        </div>
        <div className="Project-content col-6">
          <h1>{testData.title}</h1>
          <p className="Project-text">
            <strong>
            {testData.type}
            <br />
            {testData.attribution}
            <br />
            {testData.company}
            <br />
            {testData.sponsor}
            </strong>
          </p>
          <p className="Project-text">
            {testData.info[0].text} - 
            <br />
            {testData.info[0].cast}
          </p>
          <h5 className="Testimonial-header"><strong>Testimonials</strong></h5>
          <p className="Project-testimonial">
            "{testData.quotes[0].text}”
          </p>
          <h6 className="Testimonial-person">
            <strong>~{testData.quotes[0].attribution}</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default ProjectPage
